module.exports = __webpack_public_path__ + "static/media/telus-international.22144bcb.png";